var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,{tag:"component",class:{'popper-active': _vm.showPopper}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled && _vm.showPopper),expression:"!disabled && showPopper"}],ref:"popper",class:_vm.rootClass},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.content))]})],2),_vm._t("reference")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }